import styled from "styled-components";
import { Search } from "@styled-icons/boxicons-regular/Search";
import { Delete } from "@styled-icons/fluentui-system-filled/Delete";
import { EditAlt } from "@styled-icons/boxicons-regular/EditAlt";
import { BookOpen } from "@styled-icons/feather/BookOpen";
import { FileText } from "@styled-icons/feather/FileText";
import { Video } from "@styled-icons/feather/Video";
import { Download } from "@styled-icons/feather/Download";

interface MaterialButtonProps {
  variant?: "primary" | "warning" | "danger" | "success";
}

export const MainWrapper = styled.div`
  background-color: #f5f5f5;
  width: 100%;
  height: 100vh;
  color: #fff;

  .dropdown-item {
    color: #333 !important;
  }

  .bgdark {
    background-color: #007bc6;
    margin-left: -15px;

    a {
      background-color: #05367f;
      margin-bottom: 1px;
      color: #fff;
    }

    hr {
      border-top: 1px solid #3b95f2;
      margin: 10px 0px;
    }
  }

  .btn-primary {
    background-color: #05367f;
    display: block;
    border: 0px;
    width: 100%;
  }

  .card {
    margin: 15px 0px;
  }

  /* estilos específicos do modal de vídeo */
  .modal-dialog.video-modal {
    max-width: 900px;
  }

  .modal-dialog.video-modal .modal-content {
    border-radius: 18px;
    border: 0;
    box-shadow: 0 18px 55px rgba(15, 23, 42, 0.35);
    overflow: hidden;
  }

  .modal-dialog.video-modal .modal-header {
    border-bottom: 0;
    padding: 18px 24px 8px;
  }

  .modal-dialog.video-modal .modal-title {
    font-weight: 600;
    font-size: 18px;
    color: #111827;
  }

  .modal-dialog.video-modal .modal-body {
    padding: 12px 22px 22px;
    background: #f9fafb;
  }
`;

export const MainContent = styled.div`
  background-color: #fff;
  padding: 15px;
  display: block;
  margin: 10px 0px;
  color: #333;

  .pull-right {
    position: relative;
    float: right;
  }

  ul {
    list-style: none;
    padding: 0px;
    margin: 0px;
    li {
      a {
        color: #333;
        font-weight: 700;
      }
    }
  }
`;

export const SearchIcon = styled(Search)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;

export const DeleteIcon = styled(Delete)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;

export const EditIcon = styled(EditAlt)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  margin-top: -5px;
`;

// Componentes para cards de materiais no estilo moderno
export const MaterialCard = styled.div`
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: none;
  overflow: hidden;
  position: relative;
  min-height: 380px;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #007bc6, #0056b3, #28a745);
  }
`;

export const MaterialHeader = styled.div`
  padding: 20px 15px 15px;
  text-align: center;
  position: relative;
  flex-shrink: 0;
`;

export const MaterialContent = styled.div`
  padding: 0 15px 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const MaterialIcon = styled.div`
  width: 60px;
  min-width: 60px;
  height: 60px;
  min-height: 60px;
  margin: 0 auto 15px;
  background: linear-gradient(135deg, #007bc6 0%, #0056b3 100%);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 20px rgba(0, 123, 198, 0.3);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 123, 198, 0.4);
  }
`;

export const MaterialBadge = styled.span`
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;

  &.arquivo {
    background: linear-gradient(135deg, #dc3545, #c82333);
    color: white;
  }

  &.video {
    background: linear-gradient(135deg, #6f42c1, #5a32a3);
    color: white;
  }

  &.noticia {
    background: linear-gradient(135deg, #007bff, #0056b3);
    color: white;
  }

  &.default {
    background: linear-gradient(135deg, #28a745, #1e7e34);
    color: white;
  }
`;

export const MaterialTitle = styled.div`
  display: block;
  width: 100%;
  position: relative;
  min-height: 45px;
  overflow: hidden;
  padding: 8px 0px;
  font-size: 14px;
  line-height: 1.3;
  color: #2c3e50;
  font-weight: 600;
  text-align: center;
`;

export const MaterialDescription = styled.div`
  color: #6c757d;
  font-size: 12px;
  line-height: 1.4;
  text-align: center;
  margin-bottom: 15px;
`;

export const MaterialActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
  margin-top: auto;
  padding: 0 5px;
`;

export const MaterialButton = styled.button<MaterialButtonProps>`
  background: ${(props) => {
    switch (props.variant) {
      case "danger":
        return "linear-gradient(135deg, #dc3545, #c82333)";
      case "warning":
        return "linear-gradient(135deg, #ffc107, #e0a800)";
      case "success":
        return "linear-gradient(135deg, #28a745, #1e7e34)";
      default:
        return "linear-gradient(135deg, #007bff, #0056b3)";
    }
  }};
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 18px;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  margin: 2px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.2);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 18px rgba(241, 239, 239, 0.3);
    color: white;
    text-decoration: none;
  }

  &:active {
    transform: translateY(0);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
  }
`;

export const BookOpenIcon = styled(BookOpen)`
  color: #fff;
  height: 24px;
  width: 24px;
`;

export const FileTextIcon = styled(FileText)`
  color: #fff;
  height: 24px;
  width: 24px;
`;

export const VideoIcon = styled(Video)`
  color: #fff;
  height: 24px;
  width: 24px;
`;

export const DownloadIcon = styled(Download)`
  color: #fff;
  height: 18px;
  width: 18px;
  margin-right: 8px;
`;

/* wrapper pro player de vídeo */
export const VideoWrapper = styled.div`
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
  overflow: hidden;
  border-radius: 16px;
  background: #000;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.45);

  /* camada invisível só na faixa do título:
     - aparece o título normal
     - mas não recebe clique para abrir o youTube */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 42px;          /* ajusta se precisar maior/menor */
    background: transparent;
    z-index: 2;
    pointer-events: auto;  /* intercepta os cliques nessa faixa */
    cursor: default;
  }

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
    pointer-events: auto;   /* resto do vídeo continua clicável */
  }
`;